/**
 * Header
 */
(() => {
  const header = document.querySelector('header');
  if (!header) return;
  const zoneTop = document.querySelector('.zonetop');
  const pageContent = document.querySelector('.page-content');

  // Check is the hero has the class-header transparent
  const headerTransparent = document.querySelector('.header-transparent');
  if (headerTransparent) {
    header.classList.add('header-transparent');
  }

  function setElementMarginTop(element) {
    if (!element || !document.body.contains(element) || header.classList.contains('header-transparent')) {
      return;
    }
    const headerHeight = header.offsetHeight;
    element.style.marginTop = `${headerHeight}px`;
  }

  function setMargins() {
    setElementMarginTop(zoneTop || pageContent);
  }
  setMargins();

  // Scroll event listeners
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    // Clear the previous timeout if the user scrolls again
    clearTimeout(scrollTimeout);

    const currentScrollTop = Math.floor(window.pageYOffset);
    // Add the sticky class when scrolling down
    if (currentScrollTop > 50) {
      header.classList.add('sticky');
      header.classList.remove('header-transparent');
    } else {
      header.classList.remove('sticky');
      if (headerTransparent) {
        header.classList.add('header-transparent');
      }
    }
  });
})();

/**
 * Mobile header
 */
(() => {
  // Organizing the content
  const mobileHeader = document.querySelector('header .header-mobile');
  const menu = mobileHeader.querySelector('.header-menu');
  const logo = mobileHeader.querySelector('.header-logo');
  const headerRight = mobileHeader.querySelector('.header-right');
  const search = headerRight.querySelector('.header-search');

  menu.appendChild(search);

  const query = document.querySelector('header .header-full .headersection-1 .shoppingtools_container .dropdown-menu .form-group');

  if (query) {
    const login = document.querySelector('header .header-full .headersection-1 .shoppingtools_container .dropdown-menu .form-group').cloneNode(true);
    headerRight.prepend(login);
    const loginLink = login.querySelector('a');
    loginLink.innerHTML = '<i class="fa fa-bars"></i>';
  }

  const headerMain = document.createElement('div');
  headerMain.classList.add('header-main');
  headerMain.appendChild(menu);
  headerMain.appendChild(logo);
  headerMain.appendChild(headerRight);
  mobileHeader.append(headerMain);

  // Changing the search behavior
  const searchWrapper = document.createElement('div');
  searchWrapper.classList.add('header-search-wrapper');
  mobileHeader.append(searchWrapper);

  const searchInput = document.querySelector('.searchtools .widgetsearch.search.issearchpanel');
  searchWrapper.append(searchInput);

  const searchButton = search.querySelector('a');
  searchButton.removeAttribute('href');
  searchButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    searchButton.classList.toggle('active');
    searchWrapper.classList.toggle('active');
  });

  // Moving the dropdown extras to the header-right, for user dashboard link
  const dropdownExtras = document.querySelector('.dropdown-extras .dropdown-extras-btn');
  if (dropdownExtras) {
    headerRight.prepend(dropdownExtras);
  }
})();

/**
 * Changing the input placeholder
 */
(() => {
  const searchbar = document.querySelector('.widgetsearch.search');
  if (!searchbar) return;

  const input = searchbar.querySelector('input.form-control');
  input.placeholder = 'Search the site...';
})();

/**
 * Organizing the menu-right
 */
(() => {
  const header = document.querySelector('header');
  if (!header) return;

  const menuRight = header.querySelector('.menu-right');
  if (!menuRight) return;

  const profile = header.querySelector('.shoppingtools_container .toolbar');
  const miniCart = header.querySelector('.minicart_container .toolbar');

  menuRight.append(profile, miniCart);
})();

/**
 * Mini Cart
 */
(() => {
  const miniCart = document.querySelector('header .menu-right .toolbar .cart-btn a');
  if (!miniCart) return;

  const cartIcon = miniCart.querySelector('i');
  const miniCartItems = miniCart.querySelector('.minicart_count');
  const miniCartPrice = miniCart.querySelector('.minicart_total');

  // Create a div for the icon and items
  const cartInfo = document.createElement('div');
  cartInfo.classList.add('cart-info');
  cartInfo.append(cartIcon, miniCartItems);
  miniCart.prepend(cartInfo);

  // Create a div for the price and the message
  const cartPrice = document.createElement('div');
  cartPrice.classList.add('cart-price');
  cartPrice.append(miniCartPrice);
  miniCart.append(cartPrice);
  const cartMessage = document.createElement('p');
  cartMessage.classList.add('your-cart');
  cartMessage.textContent = 'Your Cart';
  cartPrice.prepend(cartMessage);
})();

/**
 * Adding contact information in the footer
 */
(() => {
  const contactFooterWrapper = document.querySelector('footer.footer .contact-footer-area');
  if (!contactFooterWrapper) return;

  // Passing the info to the links on the left
  const { phone, email, address } = EvoXLayer().session.default_branch;

  // Phone
  const phoneLink = contactFooterWrapper.querySelector('.phone');
  phoneLink.href = `tel:${phone}`;
  phoneLink.textContent = phone;

  // Email
  const emailLink = contactFooterWrapper.querySelector('.email');
  emailLink.href = `mailto:${email}`;
  emailLink.textContent = email;

  // Location
  const locationLink = contactFooterWrapper.querySelector('.location');
  const locationInfo = [
    address.line_1,
    address.line_2,
    address.line_3,
    address.city,
    address.zip,
  ].filter(Boolean).join(', ');
  locationLink.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationInfo)}`;
  locationLink.target = '_blank';
  locationLink.textContent = locationInfo;
})();

/**
 * Update the copyright year in the footer
 */
(() => {
  const yearSpan = document.querySelector('.current-year');
  const currentYear = new Date().getFullYear();
  yearSpan.textContent = currentYear;
})();

/**
 * custom-video autoplay on int observer
 */
(() => {
  const customVideo = document.querySelector('.custom-video');
  if (!customVideo) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        customVideo.play();
      }
    });
  });

  observer.observe(customVideo);
})();

/**
 * add redirect into login dropdown
 */
(() => {
  const headerLogin = document.querySelector('.header-full .dropdown-menu.account-dropdown');
  const redirectButton = document.querySelector('.redirect-button-header');

  if (headerLogin && redirectButton) {
    headerLogin.append(redirectButton);
  }
})();
